module.exports = __webpack_public_path__ + "static/media/Tierradelfuego.ec89d36c.svg";